import { REQUEST_CSRF_TOKEN, SET_CSRF_TOKEN, SET_SESSION_STATUS } from "../actions/types";

let sessionToken = localStorage.getItem("csrf");
const initialState = {
    token: sessionToken,
    loading: false,
    sessionExpired: false,
}

export default function (state = initialState, action) {
    const { type, token, expired } = action;

    switch (type) {
        case SET_CSRF_TOKEN:
            localStorage.setItem("csrf", token);
            return { ...state, token: token, loading: false };
        case REQUEST_CSRF_TOKEN:
            return { ...state, loading: true };
        case SET_SESSION_STATUS:
            return { ...state, sessionExpired: expired };
        default:
            return state;
    }
}